<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Reset Password</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              :append-icon="showpassword ? 'visibility_off' : 'visibility'"
              prepend-icon="lock"
              name="password"
              label="Password"
              id="password"
              :type="showpassword ? 'text' : 'password'"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              @keyup.enter="resetpassword"
              @click:append="() => (showpassword = !showpassword)"
            ></v-text-field>
            <v-text-field
              prepend-icon="repeat"
              name="repeatPassword"
              label="Repeat Password"
              id="repeatPassword"
              type="password"
              v-model="repeatPassword"
              :error-messages="repeatPasswordErrors"
              @input="$v.repeatPassword.$touch()"
              @blur="$v.repeatPassword.$touch()"
              @keyup.enter="resetpassword"
            ></v-text-field>
          </v-form>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="primary" to="/login">Login</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="resetpassword">Reset Password</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  },

  data () {
    return {
      showpassword: false,
      password: '',
      repeatPassword: '',
      error: null
    }
  },

  computed: {
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required.')
      !this.$v.password.minLength && errors.push('Password must be 6 characters.')
      return errors
    },
    repeatPasswordErrors () {
      const errors = []
      if (!this.$v.repeatPassword.$dirty) return errors
      !this.$v.repeatPassword.sameAsPassword && errors.push('Passwords must match.')
      return errors
    }
  },

  methods: {
    async resetpassword () {
      this.$v.$touch()

      try {
        await AuthenticationService.resetpassword({
          rid: this.$route.query.rid,
          password: this.password,
          forgotPassword: ''
        })
        this.$router.push({
          name: 'login'
        })
      } catch (error) {
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue